module.exports = (data) => ({})
